import {css} from 'aphrodite';
import React from 'react';

import {isInaccessibleInfo} from 'auth/RequestAccess';
import {PipelineStepDataKind} from 'graphql-client/__generated/graphqlGlobalTypes';
import BenchlingQuery from 'graphql-client/BenchlingQuery';
import {GetScratchFile, GetScratchFileVariables} from 'pipelines/files/network/__generated/GetScratchFile';
import {GET_SCRATCH_FILE_QUERY} from 'pipelines/files/network/GetScratchFile';
import ScratchFileChip from 'pipelines/files/ScratchFileChip';
import {renderFilePreview} from 'pipelines/files/ScratchFilePaneContent';
import {PipelineStepRawData} from 'pipelines/PipelineTypes';
import {CenteredHorizontalThrobber} from 'ui-library/HorizontalThrobber';

import {popoverPreviewStyles as styles} from './PopoverPreviewStyles';

/**
 * Popover contents for a file.
 */
export default function FilePopoverContents({
  rawData,
}: {
  rawData: PipelineStepRawData<PipelineStepDataKind.FILE>;
}): JSX.Element | null {
  return (
    <BenchlingQuery<GetScratchFile, GetScratchFileVariables>
      query={GET_SCRATCH_FILE_QUERY}
      variables={{id: rawData.id}}
      renderLoading={() => <CenteredHorizontalThrobber />}
    >
      {(data) => {
        if (isInaccessibleInfo(data.scratchFile)) {
          return null;
        }

        const filePreview = renderFilePreview(data.scratchFile);
        return filePreview ? (
          <div className={css(styles.fixedDimensionPreview)}>{filePreview}</div>
        ) : (
          <div className={css(styles.chipPreview)}>
            <ScratchFileChip scratchFile={data.scratchFile} />
          </div>
        );
      }}
    </BenchlingQuery>
  );
}
